import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Image, Input, Link } from "@nextui-org/react"

import { FilterUser } from '../../controllers/APIController';
import { passwordlessCode } from '../../controllers/SupertokenController';

const PasswordlessSignIn = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [ListOfUsers, setListOfUsers] = useState(null);
    const [verificationError, setVerificationError] = useState('');
    const [validateTest, setValidateTest] = useState(false);
    const EmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const [ValidationConditions, setValidationConditions] = useState(false);

    const handleOnNavigate = () => {
        navigate('/login');
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    useEffect(() => {
        FilterUser(email)
            .then((data) => {
                setListOfUsers(data);
            })
            .catch((err) => {
                console.log("error", err);
            });
    }, [email]);

    const validation = () => {
        let isValid = true;

        if (!email) {
            setVerificationError("Email is required");
            isValid = false;
        } else if (!EmailRegex.test(email)) {
            setVerificationError("Enter a valid email format");
            isValid = false;
        } else if (ListOfUsers === false) {
            setVerificationError("Email does not exist. Create an account.");
            isValid = false;
        } else {
            setVerificationError(null);
        }
        return isValid;
    };

    const navigateOTP = () => {
        // const isValid = validation();
        // if (isValid) {
            // setValidateTest(false);
            // const OTPBody = await passwordlessCode(email);
            // sessionStorage.setItem('email', email);
            // sessionStorage.setItem('deviceId', OTPBody.deviceId);
            // sessionStorage.setItem('preAuthSessionId', OTPBody.preAuthSessionId);
            navigate('/verify-signin');
        // } else {
        //     setValidateTest(true);
        // }
    };

    return (
        <div className="min-h-screen bg-white flex items-center justify-center p-4 text-sm relative overflow-hidden">
            {/* Background Image */}
            <div 
                className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-5"
                style={{
                    backgroundImage: "url('https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80')"
                }}
            ></div>
            
            {/* Semi-transparent overlay for better readability */}
            <div className="absolute inset-0 bg-white/80"></div>
            
            {/* Content */}
            <div className="w-full max-w-sm relative z-10">
                {/* Enhanced Form Container */}
                <div className="bg-white/95 rounded-2xl shadow-2xl border border-gray-100 p-8">
                    {/* Logo and Header */}
                    <div className="text-center mb-8">
                        <div className="flex justify-center mb-6">
                            <Image width={48} alt="Audyt Logo" src="Assets/logo.svg" />
                        </div>
                        <h1 className="text-2xl font-bold text-gray-900 mb-2">
                            Passwordless Sign In
                        </h1>
                        <p className="text-gray-600 text-base">
                            Enter your email to receive a verification code
                        </p>
                    </div>

                    {/* Error Message */}
                    {verificationError && (
                        <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg shadow-sm">
                            <p className="text-error-700 text-xs font-medium">
                                {verificationError}
                            </p>
                        </div>
                    )}

                    {/* Form */}
                    <form className="space-y-4 mb-6">
                        <div>
                            <Input
                                radius="md"
                                variant="bordered"
                                type="email"
                                label="Email"
                                placeholder="Enter your email"
                                value={email}
                                onChange={handleEmailChange}
                                labelPlacement="outside"
                                classNames={{
                                    label: "text-gray-700 font-medium text-sm",
                                    input: "text-gray-900 text-sm",
                                    inputWrapper: "bg-white border-gray-300 hover:border-primary-400 focus-within:border-primary-500 focus-within:shadow-md transition-all duration-200 h-10 shadow-sm",
                                }}
                            />
                        </div>

                        <Button
                            id="CreateAccount"
                            radius="md"
                            onClick={navigateOTP}
                            className="w-full h-10 bg-primary-600 text-white font-semibold hover:bg-primary-700 hover:shadow-lg transition-all duration-200 text-sm shadow-md"
                            size="sm"
                        >
                            Receive verification code
                            <lord-icon
                                src="https://cdn.lordicon.com/vduvxizq.json"
                                trigger="hover"
                                target="#CreateAccount"
                                
                                style={{
                                    width: "16px",
                                    height: "16px",
                                }}
                            />
                        </Button>
                    </form>

                    {/* Recommendation */}
                    <div className="flex items-center gap-2 p-3 bg-gray-50 rounded-lg mb-6 border border-gray-200">
                        <lord-icon
                            src="https://cdn.lordicon.com/yxczfiyc.json"
                            trigger="hover"
                            
                            style={{
                                width: "14px",
                                height: "14px",
                            }}
                        />
                        <span className="text-xs text-gray-600">We recommend using your work email</span>
                    </div>

                    {/* Back to Sign In */}
                    <div className="text-center">
                        <span className="text-gray-600 text-sm">
                            Prefer password sign in?{" "}
                            <button
                                onClick={() => navigate("/sign-in")}
                                className="text-primary-600 hover:text-primary-700 font-semibold transition-colors"
                            >
                                Sign in here
                            </button>
                        </span>
                    </div>

                    {/* Terms */}
                    <div className="mt-6 pt-4 border-t border-gray-100">
                        <p className="text-xs text-gray-500 text-center leading-relaxed">
                            By signing in, you agree to our{" "}
                            <Link href="#" size="sm" className="text-primary-600 hover:text-primary-700">
                                Terms of Service
                            </Link>{" "}
                            and{" "}
                            <Link href="#" size="sm" className="text-primary-600 hover:text-primary-700">
                                Privacy Policy
                            </Link>
                            .
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PasswordlessSignIn;